// 必须最先执行，先于任何 preact / tdesign-react / stuck-reporter 依赖求值。
import './polyfills';
import { init as initStuckReporter } from '@cloudstudio/stuck-reporter';
import './style';
import './style/myModal.css';
import { render } from 'preact';
import App from './components/app';
import NewApp from './components/NewApp';
import { getChannelSource, getAppParams } from './components/app.util';
import intl from 'react-intl-universal';

const locales = {
  en: require('./locales/en-us.json'),
  'zh-cn': require('./locales/zh-cn.json'),
};

const { locale } = getAppParams();
const { isIntegration } = getChannelSource();

// 页面加载完成即启动 stuck-reporter 采集，必须放在 render 之前，
// 才能吃到首屏 JS 里的 console / fetch 事件。
initStuckReporter({
  endpoint: '/api/public/telemetry',
  stuckMs: 30000,
  getIdentifier: () => {
    const pathname = window.location.pathname || '';
    const parts = pathname.split('/').filter(Boolean);
    // pathname 形如 /ws/vmanjk，末段就是 spaceKey；取不到就留空，identifier 依旧带 href
    const spaceKey = parts.length >= 2 ? parts[parts.length - 1] : '';
    // preact vnode.props 兜底次数（治标补丁副产品，帮助后续排查是否命中）
    let preactPatched = 0;
    try {
      preactPatched = (window.__preactPatchStats && window.__preactPatchStats().patched) || 0;
    } catch {
      // 忽略
    }
    return {
      app: 'workspace-loader',
      spaceKey,
      href: window.location.href,
      referrer: document.referrer,
      preactPatched,
    };
  },
  // 独立模式：pathname 跳到 /tty/ 就算就绪。
  // 嵌入模式（/ws/embeded 在 iframe 里陪跑 IDE，不跳走）：iframe 存活即视为就绪，
  // 避免 watchdog 永远命中导致 stuck 假阳性。
  isReady: () => {
    try {
      if (window.location.pathname.startsWith('/tty/')) return true;
      if (window.location.pathname.startsWith('/ws/embeded') && window.parent !== window) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  },
});

intl
  .init({
    currentLocale: Object.keys(locales).includes(locale) ? locale : 'zh-cn',
    locales,
  })
  .then(() => {
    // NewApp：新架构下的loading页面，目前仅作为error页面，后续逐步迁移
    render(isIntegration ? <NewApp /> : <App />, document.body);
  });
